<template>
  <div class="message-error u-bg--red-soft u-color--red">
    Oups... Une erreur est survenue
  </div>
</template>

<script>
  export default {
    name: "Error"
  }
</script>

<style lang="scss">
  .message-error {
    padding: rem(10px) rem(20px);
    border-radius: 2px;
    font-size: rem(14px);
    margin-bottom: rem(20px);
    }
</style>